import React from 'react';
import propTypes from 'prop-types';
;;
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control, Field as BulmaField } from 'src/ui/mui-ui-kit';;
import { usePoseWithBulma } from 'src/ui/hooks';
import { FadeInDiv, AnimatedCard } from 'src/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Radio, RadioGroup } from 'rsuite';

export function SetStatusModal({ isActive, onCancel, onSubmit }) {
  const { businessName, status } = isActive;
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );
  const [value, setValue] = React.useState(status);

  const statusTypes = [
    { label: 'Active', value: 'Active' },
    { label: 'Initiated', value: 'Initiated' },
    { label: 'Processing', value: 'Processing' },
    { label: 'Submitted', value: 'Submitted' },
    { label: 'Not Active', value: 'Not Active' },
    { label: 'In Review', value: 'In Review' },
    { label: 'Archived', value: 'Archived' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Withdrawn', value: 'Withdrawn' },
    { label: 'Declined', value: 'Declined' },
    { label: 'Closed', value: 'Closed' },
    { label: 'Dormant', value: 'Dormant' },
    { label: 'Paid Off', value: 'Paid Off' },
    { label: 'Terminated', value: 'Terminated' },
  ];
  return (
    <Modal isActive={isModalVisible} className="add-person-modal">
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        {/* <InnerLoader visible={submitting} /> */}
        <ModalCardHeader>
          <ModalCardTitle
            tag="h5"
            className="has-text-weight-semibold columns is-vcentered"
          >
            <Column isSize="narrow" tag="span">
              <span className="icon is-medium has-icon-gradient-bright">
                <FontAwesomeIcon icon={['fas', 'user-circle']} size="lg" />
              </span>
            </Column>
            <Column tag="span" hasTextColor="primary" isPaddingless>
              Set Status of {businessName}
            </Column>
          </ModalCardTitle>
        </ModalCardHeader>
        <ModalCardBody>
          <Columns isMultiline>
            <Column isSize="full">
              <RadioGroup value={value} onChange={setValue}>
                {statusTypes.map((s, i) => (
                  <Radio key={i} value={s.value}>
                    {s.label}
                  </Radio>
                ))}
              </RadioGroup>
            </Column>
          </Columns>
          <BulmaField isGrouped="centered">
            <Control>
              <Button hasTextColor="info" onClick={() => onCancel()}>
                Cancel
              </Button>
            </Control>
            <Control>
              <Button
                isColor="gradient-bright"
                type="submit"
                onClick={() => onSubmit(isActive, value)}
                disabled={value === status}
              >
                Submit
              </Button>
            </Control>
          </BulmaField>
        </ModalCardBody>
      </ModalCard>
    </Modal>
  );
}

SetStatusModal.propTypes = {
  isActive: propTypes.object.isRequired,
  onCancel: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
};
